import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { authApi } from '../utils/authApi';
import './Dashboard.css';

const Dashboard = () => {
  const { user, token, logout } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selectedOrder, setSelectedOrder] = useState(null);

  useEffect(() => {
    // console.log('📊 Dashboard Loaded with User:', {
    //   userId: user?.id,
    //   username: user?.username,
    //   email: user?.email,
    //   role: user?.role,
    //   roleName: user?.role?.name,
    //   roleType: user?.role?.type,
    //   isAdmin: user?.role?.name === 'admin',
    // });

    const fetchOrders = async () => {
      try {
        const response = await authApi.getUserOrders(user.email, token);
        setOrders(response.data || []);
      } catch (err) {
        console.error('❌ Error fetching orders:', err);
        setError('Kan bestellingen niet laden');
      } finally {
        setLoading(false);
      }
    };

    if (user?.id && token) {
      fetchOrders();
    }
  }, [user, token]);

  const getStatusColor = (status) => {
    const colors = {
      pending: '#ffd60a',
      paid: '#00d9ff',
      processing: '#ff006e',
      shipped: '#00bcd4',
      completed: '#4caf50',
      cancelled: '#ff4444',
    };
    return colors[status] || '#aaa';
  };

  const getStatusLabel = (status) => {
    const labels = {
      pending: 'In afwachting',
      paid: 'Betaald',
      processing: 'Verwerken',
      shipped: 'Verzonden',
      completed: 'Voltooid',
      cancelled: 'Geannuleerd',
    };
    return labels[status] || status;
  };

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <div>
          <h1>Dashboard</h1>
          <p className="welcome-text">Welkom, {user?.username || user?.email}!</p>
        </div>
        <button className="logout-btn" onClick={logout}>
          Uitloggen
        </button>
      </div>

      <div className="dashboard-content">
        <div className="orders-section">
          <h2>Je Bestellingen</h2>

          {error && <div className="error-message">{error}</div>}

          {loading ? (
            <div className="loading">Je bestellingen worden geladen...</div>
          ) : orders.length === 0 ? (
            <div className="empty-state">
              <p>Je hebt nog geen bestellingen geplaatst.</p>
              <a href="/shop" className="btn-primary">
                Ga Winkelen
              </a>
            </div>
          ) : (
            <div className="orders-list">
              {orders.map((order) => (
                <div
                  key={order.id}
                  className="order-card"
                  onClick={() =>
                    setSelectedOrder(
                      selectedOrder?.id === order.id ? null : order
                    )
                  }
                >
                  <div className="order-header">
                    <div className="order-info">
                      <h3>Bestelling #{order.id}</h3>
                      <p className="order-date">
                        {new Date(order.createdAt).toLocaleDateString('nl-NL')}
                      </p>
                    </div>
                    <div className="order-status">
                      <span
                        className="status-badge"
                        style={{ backgroundColor: getStatusColor(order.status) }}
                      >
                        {getStatusLabel(order.status)}
                      </span>
                      <p className="order-total">
                        €{((order.orderTotal || 0) / 100).toFixed(2)}
                      </p>
                    </div>
                  </div>

                  {selectedOrder?.id === order.id && (
                    <div className="order-details">
                      <div className="detail-row">
                        <label>Klantnaam:</label>
                        <span>{order.customer_name}</span>
                      </div>
                      <div className="detail-row">
                        <label>E-mail:</label>
                        <span>{order.customer_email}</span>
                      </div>
                      <div className="detail-row">
                        <label>Artikelen:</label>
                        <span>
                          {(() => {
                            try {
                              const items = JSON.parse(order.items);
                              return Array.isArray(items)
                                ? items.map((item) => item.name).join(', ')
                                : order.items;
                            } catch {
                              return order.items;
                            }
                          })()}
                        </span>
                      </div>
                      {order.mollie_payment_id && (
                        <div className="detail-row">
                          <label>Betalings-ID:</label>
                          <span>{order.mollie_payment_id}</span>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="profile-section">
          <h2>Profielgegevens</h2>
          <div className="profile-card">
            <div className="profile-field">
              <label>E-mailadres</label>
              <p>{user?.email}</p>
            </div>
            <div className="profile-field">
              <label>Naam</label>
              <p>{user?.username}</p>
            </div>
            <div className="profile-field">
              <label>Accounttype</label>
              <p>{user?.role?.name === 'admin' ? 'Beheerder' : 'Gebruiker'}</p>
            </div>
            {user?.role?.name === 'admin' && (
              <a href="/admin" className="btn-admin">
                Ga naar Beheerderspaneel
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
